import React, { Component } from 'react'
//import { useMediaQuery } from '../../hooks';
import { connect } from 'react-redux'
import Modal from 'react-modal'
import * as properties from '../../constants/Properties'
import {
  setOverrideModal,
  setOverrideModalView,
  setTicketReference,
  setTicketQuantity,
  toggleSelectedCustomer
} from '../actions/ticketActions'
import { getTranslation } from '../../actions/dataActions'
import * as resource from '../../constants/Resources'

class TicketOverrideModal extends Component {
  constructor(props) {
    super(props);
    this.confirmTap = this.confirmTap.bind(this);
    this.cancelTap = this.cancelTap.bind(this);
    this.goToArticleTap = this.goToArticleTap.bind(this);
    this.goToCustomerTap = this.goToCustomerTap.bind(this);
    this.goToConfirmTap = this.goToConfirmTap.bind(this);
    this.isNoArticleSelected = this.isNoArticleSelected.bind(this);
    this.isNoCustomerOrReferenceSelected = this.isNoCustomerOrReferenceSelected.bind(this);
  }

  confirmTap() {
    const { overrideModal, setOverrideModal } = this.props;

    if (overrideModal.onConfirm) {
      overrideModal.onConfirm();
    }

    setOverrideModal(false);
  }

  goToArticleTap() {
    const { setOverrideModalView } = this.props;
    setOverrideModalView("article");
  }

  goToCustomerTap() {
    const { setOverrideModalView } = this.props;
    setOverrideModalView("customer");
  }

  goToConfirmTap() {
    const { setOverrideModalView } = this.props;
    setOverrideModalView("confirm");
  }

  cancelTap() {
    const { overrideModal, setOverrideModal } = this.props;

    setOverrideModal(false);

    if (overrideModal.onCancel) {
      overrideModal.onCancel();
    }
  }

  isNoArticleSelected() {
    const articles = this.props.overrideModal.articles;
    return !(articles && articles.filter(article => article.SelectedQuantity && article.SelectedQuantity > 0).length > 0);
  }

  isNoCustomerOrReferenceSelected() {
    const { customers, reference} = this.props.overrideModal;
    return !((reference && reference !== "") || (customers && customers.find(customer => customer.Selected)));
  }

  render() {
    const { overrideModal, getTranslation, setTicketReference, setTicketQuantity, toggleSelectedCustomer } = this.props;
    const labelYes = getTranslation(resource.LABEL_YES);
    const labelNo = getTranslation(resource.LABEL_NO);
    const confirmAllowAccess = getTranslation(resource.CONFIRM_ALLOW_ACCESS);
    const selectedCustomer = overrideModal.customers && overrideModal.customers.find(customer => customer.Selected);

    return (
      <Modal id="ticketOverrideModal"
        contentLabel=""
        isOpen={overrideModal.visible}
        style={properties.confirmModalStyle}
      >
        {overrideModal.view === "article" &&
          <div className="modalContent">
            <div className="tom-label">{getTranslation(resource.SELECT_TICKETS_AND_QUANTITY)}</div>
            <div className="tom-scroll-container">
              {overrideModal.articles && overrideModal.articles.map((item, index) => {
                return (
                  <div key={`article-${index}`} className="tom-article">
                    <div className="tom-label">{item.Description}</div>
                    <div className="ticket-amount-container">
                      <input
                        className="ticket-amount-input"
                        type="number"
                        min="0"
                        max="99"
                        onChange={e => setTicketQuantity(item.ArticleNumber, e.target.value)}
                        value={item.SelectedQuantity || ""}
                        placeholder="0"
                      />
                    </div>
                  </div>
                )
              })}
            </div>
            <button className="modalButton deny" onClick={this.cancelTap}>
              {getTranslation(resource.CANCEL)}
            </button>
            <button className="modalButton approve" disabled={this.isNoArticleSelected()} onClick={this.goToCustomerTap}>
              {getTranslation(resource.NEXT)}
            </button>
          </div>
        }
        {overrideModal.view === "customer" &&
          <div className="modalContent">
            <div className="modalText ticket-override">{getTranslation(resource.SELECT_CUSTOMER_OR_REFERENCE)}</div>
            <div className="tom-scroll-container">
              {overrideModal.customers && overrideModal.customers.map((item, index) => {
                return (
                  <div
                    key={`customer-${index}`}
                    className={`tom-article ${(item.Selected ? "selected" : "")}`}
                    onClick={() => toggleSelectedCustomer(item.CustomerId)}
                  >
                    <div className="tom-label">{item.Name}</div>
                  </div>
                )
              })}
              <div key={`customer-reference`} className={`tom-article ${(overrideModal.reference && overrideModal.reference !== '' ? "selected" : "")}`}>
                <input
                  className="ticket-reference-input"
                  type="text"
                  placeholder={getTranslation(resource.TICKET_REFERENCE)}
                  onChange={e => setTicketReference(e.target.value)}
                  value={overrideModal.reference || ""}
                />
              </div>
            </div>
            <div className="modalButtons">
              <button className="modalButton deny" onClick={this.goToArticleTap}>
                {getTranslation(resource.BACK)}
              </button>
              <button className="modalButton approve" disabled={this.isNoCustomerOrReferenceSelected()} onClick={this.goToConfirmTap}>
                {getTranslation(resource.NEXT)}
              </button>
            </div>
          </div>
        }
        {overrideModal.view === "confirm" &&
          <div className="modalContent">
            <div className="modalText ticket-override">{confirmAllowAccess}</div>
            <div className="modalText ticket-resume tom-article">
              {overrideModal.reference && overrideModal.reference !== "" &&
                <div>{getTranslation(resource.TICKET_REFERENCE)}: {overrideModal.reference}</div>}
              {selectedCustomer &&
                <div>{getTranslation(resource.CUSTOMER)}: {selectedCustomer.Name}</div>}
              <div className="ticket-list">
                {overrideModal.articles && overrideModal.articles.filter(item => item.SelectedQuantity && item.SelectedQuantity > 0).map((item, index) =>
                  <div key={`ticket-${index}`}>
                    {item.SelectedQuantity}x {item.Description}
                  </div>
                )} 
                </div>
            </div>
            <div className="modalButtons">
              <button className="modalButton deny" onClick={this.cancelTap}>
                {labelNo}
              </button>
              <button className="modalButton approve" onClick={this.confirmTap}>
                {labelYes}
              </button>
            </div>
          </div>
        }
      </Modal>
    )
  }
}

function mapStateToProps(state) {
  return {
    overrideModal: state.ticket.overrideModal
  }
}

export default connect(mapStateToProps, {
  setOverrideModal,
  setOverrideModalView,
  setTicketReference,
  getTranslation,
  setTicketQuantity,
  toggleSelectedCustomer
})(TicketOverrideModal)



// WEBPACK FOOTER //
// src/ticket/components/TicketOverrideModal.jsx